export default __webpack_public_path__ + "static/media/logo-dark.932fa86f.png";